<template>
  <svg
    width="168"
    height="95"
    viewBox="0 0 168 95"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect
      width="168"
      height="94.5"
      transform="translate(0 0.5)"
      fill="none"
    />
    <rect
      x="26"
      y="45"
      width="20"
      height="39"
      :fill="colors[0]"
    />
    <rect
      x="50"
      y="63"
      width="20"
      height="21"
      :fill="colors[1]"
    />
    <rect
      x="74"
      y="55"
      width="20"
      height="29"
      :fill="colors[2]"
    />
    <rect
      x="98"
      y="63"
      width="20"
      height="21"
      :fill="colors[3]"
    />
    <rect
      x="122"
      y="73"
      width="20"
      height="11"
      :fill="colors[4]"
    />
    <line
      x1="16"
      y1="83.5"
      x2="152"
      y2="83.5"
      stroke="#D3D7E1"
    />
  </svg>
</template>
<script>
export default {
  props: {
    colors: {
      type: Array,
      default: () => [
        '#fff',
        '#fff',
        '#fff',
        '#fff',
        '#fff',
      ],
    },
  },
}
</script>
